import Controller from '@ember/controller';

export default class DownloadIdnowController extends Controller {
  queryParams = ['id', 'type'];
}
